<template>
  <div class="subscribe-preview">
    <p>
      Join the JAND newsletter<br>
      <span>Keep up with new strips and announcements</span>
    </p>
    <subscribe />
  </div>
</template>

<script>
import Subscribe from '@/views/Subscribe.vue';

export default {
  name: 'SubscribePreview',
  components: {
    Subscribe,
  },
};
</script>

<style lang="scss" scoped>
.subscribe-preview {
  width: 100%;
  height: 180px;
  border: solid 3px var(--color-link-inactive);
  border-radius: var(--radius);
  padding: 0 20px;
  p {
    font-weight: 500;
    span {
      color: var(--color-link-inactive);
      font-size: var(--font-input);
      font-weight: normal;
    }
  }
}
</style>
